
import BuilderInputs from 'components/builder/builder-inputs.vue'

import {makeTestSkillSchema} from './test-skills-defs'

const model_def = {
  name: '',
  title: '',
  command: '',
  description: '',
  example: '',
  prompt: '',
  subagents: []
}

export default {
  components: {BuilderInputs},
  props: {
    limitReached: {type: Boolean, default: false},
    agents: {type: Array, default: () => []}
  },
  emits: ['add', 'save', 'update:editing_idx'],
  data() {
    return {
      fields: {...model_def, subagents: []},
      prev_fields: undefined,

      valid: true,
      editing_idx: undefined,
    }
  },
  computed: {
    has_diff() {
      const prev = this.prev_fields || model_def
      return JSON.stringify(this.fields) !== JSON.stringify(prev)
    },
    schema() {
      return makeTestSkillSchema(this.agents.map(agent => agent.name))
    },
    can_save() {
      return this.valid && this.has_diff && (this.editing_idx !== undefined || !this.limitReached)
    }
  },
  methods: {
    edit(skill, index) {
      this.editing_idx = index
      this.fields = {...model_def, ...skill, subagents: [...(skill.subagents || [])]}
      this.prev_fields = {...this.fields, subagents: [...this.fields.subagents]}
    },
    discard() {
      this.prev_fields = undefined
      this.fields = {...model_def, subagents: []}
      this.editing_idx = undefined
    },
    onSkillDeleted(index) {
      if (this.editing_idx === index) this.discard()
      else if (this.editing_idx > index) this.editing_idx -= 1
    },
    submit() {
      if (!this.can_save) return
      const draft = {...this.fields, subagents: [...this.fields.subagents]}
      if (this.editing_idx === undefined) this.$emit('add', draft)
      else this.$emit('save', this.editing_idx, draft)
      this.discard()
    }
  }
}
